import { z } from 'zod';

/** Morning briefing: one notification per person with their day, at the company's chosen hour. */
export const briefingSettingsSchema = z.object({
  enabled: z.boolean(),
  /** Hour of the day (company time zone), e.g. 9 for 9 am. */
  hour: z.coerce.number().int().min(5).max(12),
  /** A lead with no activity for this many days counts as "going cold". */
  coldDays: z.coerce.number().int().min(2).max(60),
  /** Each person gets their own day (follow-ups, new leads, tasks, cold leads). */
  staff: z.boolean(),
  /** Managers and admins also get the team's day (late follow-ups by person, unassigned leads, yesterday's calls). */
  managers: z.boolean(),
});
export type BriefingSettings = z.infer<typeof briefingSettingsSchema> & { lastSentOn?: string };
export const DEFAULT_BRIEFING: BriefingSettings = { enabled: true, hour: 9, coldDays: 7, staff: true, managers: true };
